module.exports = __webpack_public_path__ + "static/media/icon-sante.55430419.svg";